export type AuthState = 'authenticated' | 'unauthenticated' | 'failed';

export abstract class AuthSession {
  abstract restore(): Promise<AuthState>;
  abstract signIn(returnTo: string): Promise<void>;
  abstract renewTunnel(): Promise<void>;
  abstract signInPending(): boolean;
  abstract clearPendingSignIn(): void;
}
